/************** scripts for the quotation form on the category overview page ************/

jQuery(document).ready(function(){
    jQuery('.quotation-form input[name=group_size], .search-form input[name=group_size]').val(Cookies.get('quotation_group_size'));
    jQuery('.quotation-form input[name=date], .search-form input[name=date]').val(Cookies.get('quotation_date'));
    jQuery('.quotation-form select[name=sub_category]').val(Cookies.get('sub_category'));
    /*.prepend('<option value="'+Cookies.get('sub_category')+'">'+Cookies.get('sub_category')+'</option>') */
    jQuery('.datepicker').each(function(){
        var $this = jQuery(this);
        var today = new Date();
        var yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
        var availableMonths = '';
        if (typeof $this.attr('data-months-available') !== typeof undefined && $this.attr('data-months-available') !== false) {
            availableMonths = $this.attr('data-months-available').split(',');
        }

        $this.datepicker({
            dayNamesMin: [ "zo", "ma", "di", "wo", "do", "vr", "za" ],
            dateFormat: 'd MM yy',
            beforeShowDay: function(date){
                var month = (date.getMonth() + 1).toString();
                if(date < yesterday){
                    return [false, "disabled", 'Je kunt geen datum in het verleden boeken.'];
                }
                else if(!availableMonths.includes(month) && availableMonths.length > 1){
                    return [false, "disabled"];
                }
                else{
                    return [true, "enabled"];
                }
            }
        });
    });

    var dropDownParent = jQuery('.sub-category-dropdown-container');
    if(jQuery(window).width() < 850){ dropDownParent = jQuery('.mobile-sub-category-dropdown-container'); }
    jQuery('.select2').select2({
        placeholder: 'Wat wil je doen',
        minimumResultsForSearch: -1,
        dropdownParent: dropDownParent
    });

    jQuery('.select2').on('select2:open', function(e){
        if(jQuery(window).width() < 850){
            jQuery('.mobile-menu-bg').removeClass('mobile-menu-bg--hidden');
            jQuery('.mobile-menu-trigger').removeClass('mobile-menu-trigger--initial').addClass('mobile-menu-trigger--close');
            jQuery('header').addClass('headroom--menu-open');
            jQuery('.mobile-swiped-text').css({'display' : 'none'});
            setTimeout(function(){
                disableScroll();
                jQuery('.mobile-sub-category-dropdown-container').addClass('active');
            }, 100);
        }
    });
    jQuery('.select2').on('select2:select', function(e){
        if(jQuery(window).width() < 850){
            jQuery('.mobile-menu-bg').addClass('mobile-menu-bg--hidden');
            jQuery('.mobile-menu-trigger').addClass('mobile-menu-trigger--initial').removeClass('mobile-menu-trigger--close');
            jQuery('header').removeClass('headroom--menu-open');
        }
    });
    jQuery('.select2').on('select2:close', function(e){
        if(jQuery(window).width() < 850){
            enableScroll();
            jQuery('.mobile-sub-category-dropdown-container').removeClass('active');
            jQuery('.mobile-menu-bg').addClass('mobile-menu-bg--hidden');
            jQuery('.mobile-menu-trigger').addClass('mobile-menu-trigger--initial').removeClass('mobile-menu-trigger--close');
            jQuery('header').removeClass('headroom--menu-open');
            jQuery('.mobile-swiped-text').css({'display' : 'flex'});
        }
    });

    jQuery('.mobile-quotation-button').click(function(){
        jQuery('.quotation-form').submit();
    });
});

jQuery(window).load(function(){
    /* let the quotation for slide with the user on desktop etc. */
    if (jQuery(window).width() > 850) {
        var $this = jQuery('.quotation-form');
        if ($this.length) {
            var blokTop = $this.offset().top;
            var lastScrollTop = 0;
            var quotationBottom = jQuery('.quotation').offset().top + jQuery('.quotation').height();
            if($this.height() < jQuery('.quotation').height()){
                jQuery(window).scroll(function () {
                    var topDst = blokTop - jQuery(this).scrollTop();
                    var bottomTopDst = $this.offset().top + $this.height();
                    var st = jQuery(this).scrollTop();
                    if (st > lastScrollTop){
                        /* scrolling down */
                        if ($this.hasClass('fixed') && !$this.hasClass('initial')) {
                            $this.addClass('initial').removeClass('below-menu');
                        }
                        if (topDst < 0) {
                            if (!$this.hasClass('fixed')) {
                                $this.addClass('fixed').addClass('initial');
                            }
                        }
                        if(bottomTopDst > quotationBottom && $this.hasClass('fixed')){
                            $this.addClass('bottom-reached').addClass('no-transition');
                        }
                    }else{
                        /* scrolling up */
                        if ($this.hasClass('fixed') && !$this.hasClass('below-menu')) {
                            $this.addClass('below-menu').removeClass('initial');
                        }
                        if(($this.offset().top - st) > 150 && $this.hasClass('bottom-reached')){
                            $this.removeClass('bottom-reached');
                            setTimeout(function(){
                                $this.removeClass('no-transition');
                            },10);
                        }
                    }

                    if (topDst > 150) {
                        if ($this.hasClass('fixed')) {
                            $this.removeClass('fixed').removeClass('initital').removeClass('below-menu');
                        }
                    }
                    lastScrollTop = st;
                });
            }
        }
    }
});

/* includes search form as well as side quotation form */
jQuery(document).on('submit', '.quotation-form', function($){
    var $this = jQuery(this);
    Cookies.set('quotation_group_size', jQuery('input[name=group_size]').val());
    Cookies.set('quotation_date', jQuery('input[name=date]').val());
    Cookies.set('quotation_sub_category', jQuery('select[name=sub_category]').val());

    if($this.hasClass('product')){
        Cookies.set('quotation_product_id', jQuery('input[name=product_id]').val());
        window.location.href = wpdata.site_url + '/aanvraag/stap1/';
    }
    if($this.hasClass('sub-category')){
        var sub = new Array();
        sub.push(jQuery('.sub-category-name').text().trim());
        Cookies.set('compose_categories', sub);
        window.location.href = wpdata.site_url + '/aanvraag/snel-offerte/';
    }
    return false;
});


/************** scripts for the search form on the home page ************/
jQuery(document).on('submit', '.search-form', function(){
    Cookies.set('quotation_group_size', jQuery('input[name=group_size]').val());
    Cookies.set('quotation_date', jQuery('input[name=date]').val());
    //Cookies.set('sub_category', jQuery('select[name=sub_category]').val());
    window.location.href = jQuery('select[name=sub_category]').val();
    return false;
});
